<template>
  <div id="app">
    <Overlay ref="Overlay" />
    <!-- <Estadisticas ref="Estadisticas" /> -->
    <router-view/>
  </div>
</template>

<script>
  import Overlay from './components/Overlay';

  export default {
    data() {
      return {

      }
    },
    mounted() {
    },
    methods: {
    },
    components: {
      Overlay,
      Estadisticas: () => import("./components/Estadisticas"),
    }
  }

  class Civi {
    constructor(_Id, _Name, _Spe, _UU, _UT, _B, _TB) {
      this.Id = _Id,
      this.Name = _Name,
      this.Specialty = _Spe,
      this.UniqueUnits = _UU,
      this.UniqueTechs = _UT,
      this.Bonuses = _B,
      this.TeamBonus = _TB
    }
  };
</script>

<style lang="scss">
// body{
//   margin:0; padding:0;
//   background-color: rgba(0,0,0,0);
// }
body::after{
  content: "";
  opacity: 0.9;
  z-index: -1;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.aliCenter{text-align:center;}
.aliRight{text-align:right;}
.aliRightFlex{
  display: flex;
  justify-content: flex-end;
}
.pR{position:relative;}
.pA{position:absolute;}
.w100{width:100%;}
.f24{font-size:20px;}
.f30{font-size:38px;}
.f31{font-size:44px;}
.f32{font-size:50px;}
.f34{font-size:34px;}
.B{font-weight: bold;}
.nB{font-weight: normal;}
.mT10{margin-top:10px;}
.mT20{margin-top:20px;}
.mT25{margin-top:25px;}
.lH55{line-height: 55px;}
.lH24{line-height: 24px;}
.lH44{line-height: 44px;}
.mL10{margin-left:10px;}
.mR10{margin-right:10px;}
.ColorVerde{
  color: #00D815;
}
.ColorRojo{
  color: #FF0000;
}
.c555{color:#555;}
.cAAA{color:#AAA;}
.cCeleste{color:deepskyblue;}
.InvertirVertical{
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.Tachado{text-decoration:line-through;}
.PuntosSuspensivos{text-overflow: ellipsis;}
.dNone{display:none;}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.fRight{
  float:right;
}
.fLeft{
  float:left;
}
.clear{
  clear:both;
}
.dB{
  display:block;
}
.dIB{
  display:inline-block;
}
.hP{cursor:pointer;}
.vAliMiddle{vertical-align: middle;}
.DivAuxRelative{height:0px; position:relative; display:block; width:100%;}
</style>
